import styled from "styled-components";

export const Button = styled.button<{ selected?: boolean }>`
  padding: 0.5em;
  color: ${(props) => props.selected && "#BF4F74"};
  background: ${(props) => (props.selected ? "#BF4F7433" : "transparent")};
  border: 1px solid #bf4f74;
  cursor: pointer;
  border-radius: 2rem;
  min-width: 50px;
  &:hover {
    background: ${(props) => (props.selected ? "#BF4F7433" : "#BF4F7433")};
  }
`;
